module.exports = __webpack_public_path__ + "static/img/bg-pt.ecd21003.webp";